<script lang="ts">
  /* One pinned record in the sidebar. Sales pins a client, Fund pins an LP, and both
     render THIS — the two spellings had drifted (a <button> on one side picked up the
     global button radius, press-nudge and hover border; only one carried an aria-label).
     Vocabulary stays with the caller: `stage` arrives already resolved to a human label,
     `dotColor` already resolved to a token. */
  let { label, dotColor, stage = '', pinned = false, active = false, onNavigate }:
    { label: string; dotColor: string; stage?: string; pinned?: boolean;
      active?: boolean; onNavigate: () => void } = $props();

  /* Fund lists every LP, so the star is what separates a pinned row from the rest —
     position alone would not survive a scroll. It rides on the accessible name too:
     a ★ glyph reads as "black star" to a screen reader, or as nothing when hidden. */
  const caption = $derived([stage, pinned ? 'Pinned' : ''].filter(Boolean));

  function onKeydown(event: KeyboardEvent) {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      onNavigate();
    }
  }
</script>

<div class="sidebar-item sidebar-client" class:active role="button" tabindex="0"
  title={caption.length ? `${label} — ${caption.join(' · ')}` : label}
  aria-label={caption.length ? `${label}, ${caption.join(', ')}` : label}
  onclick={onNavigate} onkeydown={onKeydown}>
  <!-- The dot is colour-only, so the stage word rides on title/aria-label (DESIGN-SYSTEM §1). -->
  <span class="nav-glyph" aria-hidden="true"><span class="client-dot" style="background:{dotColor};"></span></span>
  <span class="truncate">{label}</span>
  {#if pinned}<span class="sidebar-pin-mark" aria-hidden="true">★</span>{/if}
</div>
